import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AboveHeader } from '@core/js/components/main/AboveHeader';
import { CookiesRegulationMessage } from '@core/js/components/main/CookiesRegulationMessage';
import { Header } from '@core/js/components/main/Header';
import { Menu } from '@core/js/components/main/Menu';

import { DownloadApp } from '@interlayer/js/app/components/main/DownloadApp';
import { PortalPlace } from '@interlayer/js/app/components/system/Portal/components/PortalPlace';

import { BACKBONE_APP_ROOT } from '@core/js/backbone/constants';
import { useUpdateHeaderHeight } from '@core/js/components/system/App/hooks';

import { useInDesktop } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';
import { useIsLayoutRetailRegistrationWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutRetailRegistrationWithoutHeader';
import { useIsLayoutWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutWithoutHeader';
import { useIsShowAnyPopup } from '@interlayer/js/app/hooks/useIsShowAnyPopup';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { useScrollSpy } from '@interlayer/js/app/utils/scrollSpy';
import { useIsSplashPage } from '@interlayer/js/components/system/App/buzz/hooks/useIsSplashPage';
import { setIsStickyHeader } from '@interlayer/js/components/system/Page/store/buzz/actions';
import { MIN_SCROLL_HEADER } from '@interlayer/js/components/system/Router/components/AppRouter/buzz/constants';
import { TOP_MENU_PORTAL } from '@interlayer/js/components/tagTypes/buzz/TopMenu/constants';

import { useStickyCommunication } from './hooks/useStickyCommunication';

import style from '@interlayer/js/components/system/Router/components/AppRouter/AppRouter.scss';

export const StickyHeader: React.FC = () => {
    const isSticky = useIsSplashPage();
    const isDesktop = useInDesktop();
    const pageDispatch = useDispatch();
    const stickyEl = useRef(null);
    const [isTop, setIsTop] = useState(true);
    const headerRef = useUpdateHeaderHeight();
    const isShowAnyPopup = useIsShowAnyPopup({ delay: 200 });
    const { isScrollSpy } = useScrollSpy({
        value: MIN_SCROLL_HEADER,
        handlerAfterChange: (value) => pageDispatch(setIsStickyHeader(value))
    });

    const isWithoutHeaderLayout = useIsLayoutWithoutHeader();
    const isLayoutRetailRegistration = useIsLayoutRetailRegistrationWithoutHeader();

    useEffect(() => {
        if (!isTop && isShowAnyPopup) {
            return;
        }

        setIsTop(!isScrollSpy && !isSticky && isDesktop);
    }, [isDesktop, isScrollSpy, isShowAnyPopup, isSticky, isTop]);

    useStickyCommunication(isTop);

    if (isLayoutRetailRegistration) {
        return (
            <Header />
        );
    }

    return (
        <div
            ref={headerRef}
            className={clsx(style.header, { 'is-top': isTop, isWithoutHeaderLayout })}
        >
            <div ref={stickyEl}>
                <DownloadApp />

                <CookiesRegulationMessage />

                <AboveHeader />

                <PortalPlace id={TOP_MENU_PORTAL} isHideAdminPanel />

                <div className={BACKBONE_APP_ROOT}>
                    <div className="fn-navigation-container navigation-container">
                        <Header />

                        <Menu />
                    </div>
                </div>
            </div>
        </div>
    );
};
